// 校验手机号
export const  checkPhone = (rule, value, callback) => {
    if (!value) {
        return callback(new Error('手机号不能为空'));
    } else {
        const rules = /^1\d{10}$/
        if (!rules.test(value)) {
            return callback(new Error('手机号格式错误'));
        } else {
            return callback()
        }
    }
};
// 校验身份证
export const checkIdentityNumber = (rule, value, callback) => {
    const rules = /^[1-9]\d{5}(18|19|20|(3\d))\d{2}((0[1-9])|(1[0-2]))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$/;
    if (!value) {
        return callback()
    } else {
        if (!rules.test(value)) {
            return callback(new Error('身份号格式不正确'));
        } else {
            return callback()
        }
    }
};

export const isH5=()=>{
    let is_ok=null
    if (/(micromessenger)/i.test(navigator.userAgent)) {
        is_ok=true
        // alert("微信");
      } else {
        // alert("普通浏览器");
        // 判断h5还是pc true就是h5
        let client =
          /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
            navigator.userAgent
          );
        if (client) {
           is_ok=true

        } else {
          is_ok=false
        }
      }
      return is_ok
}

